window.phoneOutOfStock = [

  /* =========================================================
     APPLE
     ========================================================= */

  // Add Apple models here.


  /* =========================================================
     SAMSUNG
     ========================================================= */

  // Add Samsung models here.


  /* =========================================================
     ONEPLUS
     ========================================================= */

  // Add OnePlus models here.
"oneplus-nord-5",

  /* =========================================================
     XIAOMI
     ========================================================= */

  // Add Xiaomi / Redmi models here.
"redmi-note-13-pro-5g",

  /* =========================================================
     MOTOROLA
     ========================================================= */

  // Add Motorola models here.
"motorola-edge-70-fusion",
"motorola-edge-50-fusion",
"motorola-edge-60-fusion",
"motorola-edge-60",

  /* =========================================================
     NOTHING
     ========================================================= */

  // Add Nothing models here.


  /* =========================================================
     GOOGLE PIXEL
     ========================================================= */

  // Add Google Pixel models here.


  /* =========================================================
     REALME
     ========================================================= */

  // Add Realme models here.


  /* =========================================================
     VIVO
     ========================================================= */

  // Add Vivo models here.
"vivo-t4x",

  /* =========================================================
     OPPO
     ========================================================= */

  // Add Oppo models here.
"oppo-reno-15-pro-mini",

  /* =========================================================
     POCO
     ========================================================= */

  // Add Poco models here.


  /* =========================================================
     IQOO
     ========================================================= */

  // Add iQOO models here.
"iqoo-15r",

  /* =========================================================
     ASUS
     ========================================================= */

  // Add Asus models here.


  /* =========================================================
     SONY
     ========================================================= */

  // Add Sony models here.


  /* =========================================================
     HONOR
     ========================================================= */

  // Add Honor models here.


  /* =========================================================
     NOKIA
     ========================================================= */

  // Add Nokia models here.


  /* =========================================================
     INFINIX
     ========================================================= */

  // Add Infinix models here.
"infinix-gt-30-pro",

  /* =========================================================
     TECNO
     ========================================================= */

  // Add Tecno models here.


  /* =========================================================
     LAVA
     ========================================================= */

  // Add Lava models here.


  /* =========================================================
     HTC
     ========================================================= */

  // Add HTC models here.


  /* =========================================================
     MICROSOFT
     ========================================================= */

  // Add Microsoft models here.


  /* =========================================================
     OTHERS
     ========================================================= */

  // Add models from any other brand here.

];